import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PlayCircleIcon from "@mui/icons-material/PlayCircleFilled";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import GetAppIcon from "@mui/icons-material/GetApp";

import useCrew from "../../hooks/useCrew";
import useUser from "../../hooks/useUser";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getUserCrewTrainings } from "../../api/training.deprecated";
import { openExportWindow } from "../../api/index";
import { concatRolesUsers } from "../../services/user";
import { OkIcon, ExpiredIcon } from "../../components/CourseStatusIcon";

const UserTrainings = ({ match, history }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const onExportError = () => enqueueSnackbar(t("orders.document_not_found"), { variant: "error" });
  const [refresh, setRefresh] = useState(1);
  const { crew } = useCrew();
  const [userCrewTrainings, setUserCrewTrainings] = useState([]);
  //const { user } = useUser();
  const user = useUser();

  useEffect(() => {
    (async () => {
      const res = await getUserCrewTrainings("user", user.id, crew.id);
      setUserCrewTrainings(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.user_list")}</Typography>
      {userCrewTrainings ? (
        <TableComponent
          header={[
            { title: t("training_pages.training_id"), style: { width: "5%" } },
            { title: t("training_pages.training") },
            { title: t("training_pages.e_learning") },
            { title: t("training_pages.classroom") },
            { title: t("training_pages.practical") },
            { title: t("actions") },
          ]}
          renderChildren={(userCrewTraining) => (
            <TableRow key={userCrewTraining.id}>
              <TableCell>{userCrewTraining.training_id}</TableCell>
              <TableCell>{userCrewTraining.displayname}</TableCell>

              <TableCell>
                {userCrewTraining.is_e_learning ? userCrewTraining.elearning_status ? <OkIcon /> : <ExpiredIcon /> : ""}
              </TableCell>
              <TableCell>
                {userCrewTraining.is_classroom ? userCrewTraining.classroom_status ? <OkIcon /> : <ExpiredIcon /> : ""}
              </TableCell>
              <TableCell>
                {userCrewTraining.is_practical ? userCrewTraining.practical_status ? <OkIcon /> : <ExpiredIcon /> : ""}
              </TableCell>

              <TableCell>
                {userCrewTraining.training.is_e_learning == userCrewTraining.elearning_status &&
                userCrewTraining.training.is_classroom == userCrewTraining.classroom_status &&
                userCrewTraining.training.is_practical == userCrewTraining.practical_status ? (
                  <Button
                    title={t("training_pages.download_certificate")}
                    icon={<GetAppIcon />}
                    onClick={() => openExportWindow(userCrewTraining.course_id, user.id, onExportError)}
                  />
                ) : (
                  <Button
                    icon={<PlayCircleIcon />}
                    onClick={() =>
                      history.push(
                        `training-users/user/details/${userCrewTraining.training_id}/${user.id}/${userCrewTraining.course_id}`,
                      )
                    }
                    title={t("training_pages.go_to_course_modules")}
                  />
                )}
              </TableCell>
            </TableRow>
          )}
          search={["displayname", "fullname", "company_name"]}
          pagination
          items={userCrewTrainings}
        />
      ) : null}
    </>
  );
};

export default UserTrainings;
